import React, { createContext, useContext, useState } from 'react';

const HireNowModalContext = createContext();

export const HireNowModalProvider = ({ children }) => {
  const [showHireNowModal, setShowHireNowModal] = useState(false);
  const [editData, setEditData] = useState(null);

  const openHireNowModal = () => {
    setEditData(null);
    setShowHireNowModal(true);
  };

  const openEditModal = (jobData) => {
    setEditData(jobData);
    setShowHireNowModal(true);
  };

  const closeHireNowModal = () => {
    setShowHireNowModal(false);
    setEditData(null);
  };

  return (
    <HireNowModalContext.Provider
      value={{
        showHireNowModal,
        editData,
        openHireNowModal,
        openEditModal,
        closeHireNowModal,
      }}
    >
      {children}
    </HireNowModalContext.Provider>
  );
};

export const useHireNowModal = () => {
  return useContext(HireNowModalContext);
};
